var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-label",class:{'is-edit': _vm.isEdit},on:{"click":_vm.click}},[_vm._t("default"),(_vm.isRequired)?_c('div',{staticClass:"is-required"}):_vm._e(),(_vm.isAdmin)?_c('div',{staticClass:"is-admin"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }